import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ScrollCanvas = ({ folder = "habitat", frameCount = 165 }) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");

    canvas.width = 960;
    canvas.height = 960;

    // const currentFrame = (index) =>
    //   // `${process.env.PUBLIC_URL}/assets/${folder}/images/seq_0_${(index + 1)
    //   `${process.env.PUBLIC_URL}/assets/${folder}/images/seq_0_${(index + 1)

    //     .toString()
    //     .padStart(3, "0")}.png`;

    const currentFrame = (index) =>
      `${process.env.PUBLIC_URL}/${folder}/seq_0_${(index + 1)
        .toString()
        .padStart(3, "0")}.png`;

    const images = [];
    const airpods = {
      frame: 0,
      reverse: false,
    };

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      images.push(img);
    }

    let lastScrollTop = 0;
    const onScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      airpods.reverse = scrollTop > lastScrollTop;
      lastScrollTop = scrollTop;
    };

    window.addEventListener("scroll", onScroll);

    const render = () => {
      const frameIndex = airpods.reverse
        ? frameCount - airpods.frame - 1
        : airpods.frame;
      const image = images[frameIndex];
      if (image?.complete && image?.naturalWidth !== 0) {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0);
      }
    };

    images[0].onload = render;

    const tween = gsap.to(airpods, {
      frame: frameCount - 1,
      snap: "frame",
      ease: "none",
      scrollTrigger: {
        trigger: containerRef.current,
        start: "center 70%",
        end: "center 40%",
        scrub: 1,
        pin: true,
      },
      onUpdate: render,
    });

    return () => {
      window.removeEventListener("scroll", onScroll);
      tween.kill();
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, [folder, frameCount]);

  return (
    <div className="canvasscroll MinH100" ref={containerRef}>
      <canvas id="hero-lightpass" ref={canvasRef}></canvas>
    </div>
  );
};

export default ScrollCanvas;
